export const LAYOUT_BODY_CLASSNAME = 'payment-card-list-container';

export enum CardsView {
  OWN = 'OWN',
  COMPANY = 'COMPANY',
}
